import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";

import useStyles from "./styles";

import chunk from "lodash/chunk";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";

function SubFormCheckbox3({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  keluarga,
  pk,
  navigationMode,
  handleNextSub,
  handleBackSub,
  isSubmitting,
  subformIndex,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [show, setShow] = useState(false);

  const [jawaban, setJawaban] = useState(value.jawaban || "");
  const [lainnya, setLainnya] = useState(value.jawaban_lainnya || "");
  const [kondisi, setKondisi] = useState(value.kondisi || 0);

  useEffect(() => {
    setError({});
  }, []);

  useEffect(() => {
    // Sinkronkan state lokal dengan prop value
    if (
      value.jawaban &&
      JSON.stringify(value.jawaban) !== JSON.stringify(jawaban)
    ) {
      setJawaban(value.jawaban);
    }
    if (value.jawaban_lainnya !== lainnya) {
      setLainnya(value.jawaban_lainnya || "");
    }
    if (value.kondisi !== kondisi) {
      setKondisi(value.kondisi || 0);
    }
  }, [value]);

  useEffect(() => {
    //console.log('validation called');
    if (form.show_if.length <= 0) {
      setShow(true);
    } else {
      const cekShow = form.show_if.some((show_if) => {
        return pk[show_if.no].jawaban === show_if.value;
      });

      setShow(cekShow);
      if (!cekShow) {
        if (navigationMode === "back") {
          handleBackSub();
        } else {
          handleNextSub();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, form]);

  const { pertanyaan, definisi_operasional } = form;

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: Array.isArray(jawaban) ? jawaban.join(",") : jawaban,
      Jawaban_H1: value.kondisi || 0,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: lainnya || "",
    };
    if (value._rev) {
      normalizeValue._rev = value._rev;
    }
    if (show) {
      // console.log("Saving change value:", normalizeValue);
      saveChangeValue(normalizeValue);
    }

    //console.log("save onchange => ", normalizeValue)
  }, [jawaban, lainnya, kondisi, pertanyaan, form.no, value._rev]);

  // console.log("checkbox");

  if (!show) {
    return null;
  }

  const handleChangeCheckbox = (option_no) => (e) => {
    let selected;
    if (typeof value.jawaban === "string") {
      selected = value.jawaban.split(",").map(Number);
    } else {
      selected = value.jawaban || [];
    }
    const selectedIndex = selected.indexOf(option_no);
    let newSelected = [];

    const tidakSetujuOption = 9;

    if (form.no === "29") {
      if (option_no === tidakSetujuOption) {
        if (selectedIndex !== -1) {
          newSelected = [];
        } else {
          newSelected = [tidakSetujuOption];
        }
      } else {
        if (selected.includes(tidakSetujuOption)) {
          newSelected = [option_no];
        } else {
          if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, option_no);
          } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
          } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
          } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
              selected.slice(0, selectedIndex),
              selected.slice(selectedIndex + 1)
            );
          }
        }
      }
    } else {
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, option_no);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
    }

    setValue({ target: { name: "jawaban", value: newSelected } });

    setJawaban(newSelected);

    setError({
      ...error,
      jawaban: "",
    });

    // setSomethingChange(true)
  };

  const handleChange = (e) => {
    setValue(e);

    setError({
      ...error,
      [e.target.name]: "",
    });

    switch (e.target.name) {
      case "jawaban_lainnya":
        setLainnya(e.target.value);
        break;
      case "kondisi":
        setKondisi(e.target.value);
        break;
      default:
        break;
    }
  };
  // const handleChange = (e) => {
  //   const { value, checked } = e.target;
  //   const currentAnswers = Array.isArray(value.jawabanA) ? value.jawabanA : [];

  //   if (value === "15" && checked) {
  //     setValue({
  //       target: {
  //         name: "jawabanA",
  //         value: ["15"],
  //       },
  //     });
  //     return;
  //   }
  //   if (value !== "15" && checked && currentAnswers.includes("15")) {
  //     // Hapus "Tidak pernah" dari pilihan
  //     const newAnswers = currentAnswers.filter((item) => item !== "15");
  //     newAnswers.push(value);

  //     setValue({
  //       target: {
  //         name: "jawabanA",
  //         value: newAnswers,
  //       },
  //     });
  //     return;
  //   }

  //   if (checked) {
  //     setValue({
  //       target: {
  //         name: "jawabanA",
  //         value: [...currentAnswers, value],
  //       },
  //     });
  //   } else {
  //     setValue({
  //       target: {
  //         name: "jawabanA",
  //         value: currentAnswers.filter((item) => item !== value),
  //       },
  //     });
  //   }

  //   // setValue(e);

  //   // setError({
  //   //   ...error,
  //   //   [e.target.name]: "",
  //   // });

  //   // switch (e.target.name) {
  //   //   case "jawaban_lainnya":
  //   //     setLainnya(e.target.value);
  //   //     break;
  //   //   case "kondisi":
  //   //     setKondisi(e.target.value);
  //   //     break;
  //   //   default:
  //   //     break;
  //   // }

  //   // setSomethingChange(true)
  // };

  const isChecked = (option_no) => {
    let convertedValue = [];
    if (typeof value.jawaban === "string") {
      convertedValue = value.jawaban.split(",").map(Number);
    } else {
      convertedValue = value.jawaban;
    }
    const selected = convertedValue || [];
    return selected.indexOf(option_no) !== -1;
  };

  const validate = () => {
    let newError = {};

    if (!value.jawaban) {
      newError.jawaban = "Wajib diisi";
    } else if (value.jawaban.length <= 0) {
      newError.jawaban = "Wajib diisi";
    }

    if (form.lain) {
      if (isChecked(form.options.length) && !value.jawaban_lainnya) {
        newError.jawaban_lainnya = "Wajib diisi";
      }
    }

    if (form.kondisi) {
      if (typeof value.kondisi === "undefined") {
        newError.kondisi = "Kondisi wajib diisi";
      }
    }

    return newError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setValue({ target: { name: "jawaban", value: jawaban } });
    if (lainnya) {
      setValue({ target: { name: "jawaban_lainnya", value: lainnya } });
    }
    if (kondisi) {
      setValue({ target: { name: "kondisi", value: kondisi } });
    }
    setTimeout(() => {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
      } else {
        let normalizeValue = {
          Pertanyaan: pertanyaan,
          Jawab_Pilih: Array.isArray(jawaban) ? jawaban.join(",") : jawaban,
          Jawaban_H1: kondisi || 0,
          Jawaban_H2: 0,
          No_Pertanyaan: parseInt(form.no),
          Lainnya: lainnya || "",
        };
        if (value._rev) {
          normalizeValue._rev = value._rev;
        }

        // console.log("Submitting normalizeValue:", normalizeValue);
        saveValue(normalizeValue);
      }
    }, 100);
  };
  //console.log('here')
  const chunk_options_keys = chunk(
    Object.keys(form.options),
    form.options_chunk
  );

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>{form.no}</span>
              <span dangerouslySetInnerHTML={{ __html: pertanyaan }} />
            </Typography>
            <div style={{ position: "absolute", right: "0", top: "58px" }}>
              <InfoButton
                title={`Pertanyaan ${form.no}`}
                content={definisi_operasional}
              />
            </div>
          </div>
          <div className={classes.cardBody} style={{ paddingTop: "40px" }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  error={error.jawaban ? true : false}
                  component="fieldset"
                >
                  <FormGroup className={classes.radioGroup}>
                    <div className={classes.radioSection}>
                      {Object.keys(form.options).map((key) => {
                        const intKey = parseInt(key);
                        const nomor = parseInt(key) + 1;
                        return (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={isChecked(intKey + 1)}
                                onChange={handleChangeCheckbox(intKey + 1)}
                                value={intKey + 1}
                              />
                            }
                            label={`${nomor}. ${form.options[key]}`}
                            className={classes.fullWidthLabel}
                          />
                        );
                      })}
                      {form.lain &&
                        value.jawaban &&
                        value.jawaban.includes(form.options.length) && (
                          <TextField
                            fullWidth
                            placeholder="Tuliskan"
                            variant="outlined"
                            id="jawaban_lainnya"
                            name="jawaban_lainnya"
                            value={value.jawaban_lainnya || ""}
                            onChange={handleChange}
                            error={error.jawaban_lainnya ? true : false}
                            helperText={error.jawaban_lainnya}
                            inputProps={{
                              className: classes.inputMini,
                            }}
                          />
                        )}
                    </div>
                  </FormGroup>
                  <FormHelperText>{error.jawaban}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormCheckbox3;
